import { Progress } from "antd/es";
import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import ReactDOM from "react-dom";
import withCommonEvents from "../../../../shared/hoc/with-common-events";
import { CommonProps } from "../../common-props";

export interface ProgressBaseProps {
  percent?: number;
  percentageDirection?: "left" | "right";
  style?: any;
  size?: "small" | "medium" | "large";
  hidePercentage?: boolean;
  direction?: "horizontal" | "vertical";
  type?: string;
  value?: any;
  className?: string;
  id?: string;
}

interface ProgressBaseState {}

class ProgressBase extends PureComponent<ProgressBaseProps & CommonProps, ProgressBaseState> {
  constructor(props: ProgressBaseProps) {
    super(props);
    this.state = {};
  }

  componentDidMount(): void {
    setTimeout(() => {
      if (this.props.size === "medium" || this.props.size === "large") {
        this.handleHeight();
      }
      const node = ReactDOM.findDOMNode(this) as Element;
      const text = node?.querySelector(".ant-progress-text") as HTMLElement;
      if (text) {
        text.setAttribute("data-testid", "progress-text");
        if (this.props.style?.color && text?.style) {
          text.style.color = this.props.style.color;
        }
      }
    }, 0);
  }

  getProps = () => {
    const props: any = _.clone(this.props);
    const { style } = props;
    const safeStyle = _.clone(style || {});
    props.format = (percent: number) => {
      return props.percentageDirection === "left" ? `%${percent}` : `${percent}%`;
    };

    if (props.value) {
      props.percent = props.value.percent !== undefined ? props.value.percent : props.value;
    }
    if (safeStyle?.backgroundColor?.length > 0) {
      props.strokeColor = safeStyle.backgroundColor;
    }
    if (props.firstGradientColor && props.secondGradientColor && props.thirdGradientColor) {
      let gradientColors: any = {
        "0%": props.firstGradientColor,
        "50%": props.secondGradientColor,
        "100%": props.thirdGradientColor
      };
      if (this.props.percent <= 25) {
        gradientColors = {
          "0%": props.firstGradientColor,
          "75%": props.firstGradientColor,
          "100": props.secondGradientColor
        };
      } else if (this.props.percent <= 50) {
        gradientColors = {
          "0%": props.firstGradientColor,
          "50%": props.firstGradientColor,
          "75%": props.secondGradientColor
        };
      } else if (this.props.percent < 75) {
        gradientColors = {
          "0%": props.firstGradientColor,
          "50%": props.firstGradientColor,
          "90%": props.secondGradientColor
        };
      } else {
        gradientColors = {
          "0%": props.firstGradientColor,
          "50%": props.secondGradientColor,
          "100%": props.thirdGradientColor
        };
      }
      props.strokeColor = gradientColors;
    } else if (props.firstGradientColor && props.secondGradientColor) {
      props.strokeColor = { from: props.firstGradientColor, to: props.secondGradientColor };
    }
    delete safeStyle.backgroundColor;

    props.style = safeStyle;
    return props;
  };

  handleHeight = () => {
    const node = ReactDOM.findDOMNode(this) as Element;
    const outer = node.querySelector(".ant-progress-outer") as HTMLElement;
    const inner = node.querySelector(".ant-progress-inner") as HTMLElement;
    const progressBg = node.querySelector(".ant-progress-bg") as HTMLElement;
    const text = node.querySelector(".ant-progress-text") as HTMLElement;
    if (this.props.size === "medium") {
      outer.style.height = "16px";
      inner.style.height = "16px";
      inner.style.display = "flex";
      inner.style.alignItems = "center";
      progressBg.style.height = "16px";
      text.style.height = "1.5em";
    } else if (this.props.size === "large") {
      outer.style.height = "24px";
      inner.style.height = "24px";
      inner.style.display = "flex";
      inner.style.alignItems = "center";
      progressBg.style.height = "24px";
      text.style.height = "2em";
    }
  };

  getNumbersOfStyleProperties = (val: any) => {
    if (!val) return undefined;
    let numb: any = val?.match(/\d/g);
    numb = numb?.join("");
    return numb;
  };

  render(): ReactNode {
    const props = this.getProps();
    const percent = props.value
      ? props.value.percent !== undefined
        ? props.value.percent
        : props.value
      : props.percent;
    const style = this.props.style || {};

    return (
      <Progress
        {...this.getProps()}
        size={this.props.size || "small"}
        width={this.getNumbersOfStyleProperties(style.width)}
        height={100}
        data-testid="progress-component"
        data-percent={percent !== undefined ? percent : "undefined"}
        data-type={this.props.type}
        data-size={this.props.size || ""}
        data-hide-percentage={this.props.hidePercentage || ""}
        data-percentage-direction={this.props.percentageDirection || ""}
        className={this.props.className}
        id={this.props.id}
      />
    );
  }
}

const progressBase = withCommonEvents(ProgressBase);
export { progressBase as ProgressBase };
